import { createStore, combineReducers, applyMiddleware } from 'redux';
import ReduxThunk from 'redux-thunk';
import authReducer from '../reducers/auth';
import searchReducer from '../reducers/search';
import userInfoFormReducer from '../reducers/userInfoForm';
import deliveryAddressFormReducer from '../reducers/deliveryAddressForm';
import currentLocationReducer from '../reducers/currentLocation';
import currentMenuItemReducer from '../reducers/currentMenuItem';
import cartReducer from '../reducers/cart';
import cartItemReducer from '../reducers/cartItem';
import modalsReducer from '../reducers/modals';
import panelsReducer from '../reducers/panels';
import receiptReducer from '../reducers/receipt';

export default () => {
    const store = createStore(
        combineReducers({
            auth: authReducer,
            userInfoForm: userInfoFormReducer,
            deliveryAddressForm: deliveryAddressFormReducer,
            search: searchReducer,
            currentLocation: currentLocationReducer,
            currentMenuItem: currentMenuItemReducer,
            cart: cartReducer,
            cartItem: cartItemReducer,
            modals: modalsReducer,
            panels: panelsReducer,
            receipt: receiptReducer
        }),
        {},
        applyMiddleware(ReduxThunk)
    );

    return store;
}